import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap-5';

const LocationOptions = ({ location, onLocationChange, clearBtnRef }) => {
  const { polygonSearch } = location;

  const setPolygonSearch = (newPolygonSearch) => {
    onLocationChange({
      ...location,
      polygonSearch: newPolygonSearch
    });
  };

  return (
    <React.Fragment>
      <Form.Group className="mb-3">
        <strong>How would you like to specify your location criteria?</strong>
        <Form.Check id={`city-state-zip-checkbox-${location.id}`} type="radio">
          <Form.Check.Input checked={!polygonSearch} type="radio" onChange={() => setPolygonSearch(false)} />
          <Form.Check.Label><strong>City, State, Zip</strong></Form.Check.Label>
        </Form.Check>
        <Form.Check id={`polygon-search-${location.id}`} type="radio">
          <Form.Check.Input checked={!!polygonSearch} type="radio" onChange={() => setPolygonSearch(true)} />
          <Form.Check.Label><strong>Draw on Map</strong></Form.Check.Label>
        </Form.Check>
      </Form.Group>
      {location.polygonSearch && <div>Click on the map to start drawing.</div>}
      <div ref={clearBtnRef}>{/* To be filled by portal */}</div>
    </React.Fragment >
  );
};

LocationOptions.propTypes = {
  clearBtnRef: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  onLocationChange: PropTypes.func.isRequired
};

export default LocationOptions;
